<div class="c-login-container__row sb-router-outlet__no-header">
  <div class="c-login-container__left text-center">
    <a href="https://springbot.com/" target="_blank">
      <img src="https://springbot-assets.s3.us-east-1.amazonaws.com/images/logo-springbot-send.svg" class="sb-logo">
    </a>

    <h1 class="mt-4">Welcome back!</h1>
    <div class="mt-4">Need an account? <a routerLink="/register">Sign up</a> for free.</div>

    <div class="text-left login-form-container mt-4">
      <div class="alert alert-danger" *ngIf="!!error">{{ error }}</div>
      <form #loginForm="ngForm" (ngSubmit)="onSubmit(loginForm)" novalidate class="login-form">
        <div class="form-group field">
          <label>Email</label><br>
          <input class="form-control" name="email" [(ngModel)]="email" type="email" required
                 [ngClass]="{ 'is-invalid': !!emailError }"
                 (change)="emailError = undefined">
          <div class="invalid-feedback">
            {{ emailError }}
          </div>
        </div>

        <div class="form-group field my-3">
          <label>Password</label><br>
          <input class="form-control" name="password" [(ngModel)]="password" type="password" required
                 [ngClass]="{ 'is-invalid': !!passwordError }"
                  (change)="passwordError = undefined">
          <div class="invalid-feedback">
            {{ passwordError }}
          </div>
        </div>

        <a routerLink="/password_reset" [ngStyle]="{'pointer-events': loading ? 'none' : 'unset'}">Forgot Password?</a>
        <button class="btn btn-success w-100 mt-4" [disabled]="loading">
          <span *ngIf="!loading">Login</span>
          <fa-icon [icon]="['fas', 'cog']" *ngIf="loading" [spin]="true" size="1x" class="white-color"></fa-icon>
        </button>
      </form>
    </div>
  </div>

  <div class="c-login-container__right text-center">
    <img src="https://springbot-assets.s3.us-east-1.amazonaws.com/images/img-hero-login.jpg" class="marketing-image">
    <h1 class="text-white">Grow your audience with Springbot.</h1>
    <div class="text-white">Reach your customers with email campaigns, sign up forms,
      abandoned cart emails, and more.
    </div>
  </div>
</div>
